import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const MoonShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 398.5 391.8",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M137 250.4c-44.3-44.1-69.2-104-69-166.5C68 55.2 73.2 26.8 83.4 0 30.7 41.6-.1 105.1 0 172.3c0 121.3 98.3 219.5 219.6 219.5 71.1 0 137.7-34.4 178.9-92.3-29.9 13.2-62.2 19.9-94.9 19.9-62.5.2-122.5-24.7-166.6-69z"
    })
  });
};

export { MoonShape };
//# sourceMappingURL=MoonShape.js.map
